module.exports = __webpack_public_path__ + "images/Lyft-552e42.png";